import {
  // getMerchantList,
  getMenusTree
} from '@/api/global'

import {
  getIntroduction
} from '../../utils/auth'
// import {
//   resolve
// } from 'core-js/fn/promise'
// import {
//   response
// } from 'express'

const state = {
  // 门店的集合
  // merchantList: []
  menuList: []
}

const mutations = {
  // SET_MERCHANTLIST: (state, merchantList) => {
  //   state.merchantList = merchantList
  // },
  SET_MENU: (state, menuList) => {
    state.menuList = menuList
  }
}

const actions = {
  getMenusTree({
    commit
  }) {
    return new Promise((resolve, reject) => {
      if (state.menuList.length > 0) {
        resolve(state.menuList)
      } else {
        getMenusTree().then(response => {
          resolve(response)
          resolve(state.menuList)
        }).catch(error => {
          reject(error)
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
